import { Logger, LoggerContext, ModalManager, ModalRenderer, useModalManagerProvider } from "@kosmod/kit";
import { Component, createContext, h, useContext, useMemo } from "@lukekaalim/act";
import { KosmodSite } from "./pages";
import { NetworkClient } from "@kosmod/pancake";
import { LocalStorageService } from "./hooks";

export type FrontendCore = {
  modal: ModalManager,
  site: KosmodSite,
  net: NetworkClient,
  storage: LocalStorageService,
};

export const FrontendCoreContext = createContext<FrontendCore | null>(null)

export const useFrontendCore = () => {
  throw new Error(`useFrontendCore is deprecated`);
}

export type FrontendCoreProviderProps = {
  site: KosmodSite,
  logger: Logger,
  net: NetworkClient,
  storage: LocalStorageService
}

export const FrontendCoreProvider: Component<FrontendCoreProviderProps> = ({ site, children, logger, net, storage }) => {
  const modal = useModalManagerProvider();
  
  const feCore = useMemo(() => ({
    site,
    modal,
    net,
    storage
  }), [modal, site, net, storage])

  return h(LoggerContext.Provider, { value: logger },
    h(FrontendCoreContext.Provider, { value: feCore }, [
      children,
      h(ModalRenderer, { manager: modal })
  ]))

};